import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import welcomeIllustration from "@/assets/froppio-welcome.svg";
import { AppsList } from "../components/AppsList";

export function AppsPage() {
  return (
    <Page>
      <PageHeader
        title="More"
        actions={
          <img
            src={welcomeIllustration}
            alt="A happy Froppio waving hello"
            width={280}
            height={240}
            className="h-auto w-24 sm:w-[120px]"
          />
        }
      />
      <PageContent>
        <AppsList />
      </PageContent>
    </Page>
  );
}
